import { forwardRef } from 'react';

import connectFieldsStyles from '@components/primitives/ConnectedFields/styles.module.css';
import { useFormField } from '@components/primitives/FormField';
import { InputProps } from '@components/primitives/Input/types';
import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export type { InputProps } from './types';

/** To pair the field with icons, labels or buttons, use `InputGroup`. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, size = 'md', error, width, variant = 'default', ...props },
  ref
) {
  const formField = useFormField();

  return (
    <input
      {...props}
      ref={ref}
      id={formField?.id ?? props.id}
      className={cn(
        variant === 'default' && connectFieldsStyles.connectableField,
        css.input,
        css.control,
        className
      )}
      data-size={size}
      data-error={error ?? Boolean(formField?.error)}
      data-width={width}
      data-variant={variant}
    />
  );
});
